




































import Vue, { PropType } from "vue";
import AdvertisementPublishment from "../../entity/AdvertisementPublishment";
export default Vue.extend({
  props: {
    publishment: Object as PropType<AdvertisementPublishment>
  }
});
